import postBotAvatar from './postBotAvatar';
import postUpdateTheme from './postUpdateTheme';
import getPipeline from './getPipeline';
import addChannel from './addChannel';
import updateChannel from './updateChannel';
import deleteChannel from './deleteChannel';

export default {
  postBotAvatar,
  postUpdateTheme,
  getPipeline,
  addChannel,
  updateChannel,
  deleteChannel
};
